/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React from "react";

// eslint-disable-next-line react/prop-types
function HDCIcon({ width = 22, height = 22, ...props }) {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      xmlSpace="preserve"
      {...props}
    >
      <g fill="#003E99">
        <path
          d="M13.91,4.23c-0.31-0.29-0.61-0.59-0.93-0.86C12.53,3,12.03,2.7,11.5,2.46C10.37,1.96,9.2,1.85,8,1.99
       C7.69,2.02,7.38,2.11,7.08,2.21C6.72,2.32,6.37,2.46,6.02,2.61c-0.53,0.24-1,0.58-1.43,0.97C4.14,3.99,3.74,4.45,3.43,4.97
       C3.3,5.18,3.19,5.4,3.08,5.62C3.02,5.74,2.94,5.82,2.8,5.81c-0.34-0.01-0.67,0-1.01,0c-0.17,0-0.23-0.06-0.15-0.21
       c0.22-0.42,0.44-0.85,0.7-1.25c0.34-0.53,0.78-0.98,1.26-1.4C4,2.61,4.43,2.31,4.9,2.08C5.26,1.9,5.64,1.74,6.02,1.59
       c0.16-0.06,0.33-0.1,0.49-0.14C7.43,1.24,8.36,1.2,9.29,1.33c0.77,0.11,1.5,0.36,2.2,0.73c0.91,0.47,1.66,1.13,2.32,1.91
       c0.06,0.07,0.1,0.16,0.15,0.24C13.94,4.21,13.93,4.22,13.91,4.23z"
        />
        <path
          d="M13.96,12.32c-0.04,0.07-0.08,0.15-0.13,0.22c-0.51,0.63-1.09,1.19-1.78,1.62c-0.36,0.23-0.76,0.4-1.15,0.58
       c-0.58,0.28-1.21,0.44-1.84,0.49c-0.63,0.04-1.27,0.04-1.9-0.03c-0.56-0.06-1.1-0.24-1.63-0.45c-1.11-0.45-2.03-1.15-2.8-2.05
       c-0.4-0.47-0.74-1-0.99-1.58c-0.04-0.09-0.08-0.17-0.12-0.25c-0.03-0.09,0.02-0.14,0.1-0.14c0.38,0,0.76-0.01,1.14,0.01
       c0.07,0,0.16,0.09,0.19,0.16c0.41,0.92,1.04,1.66,1.8,2.29c0.44,0.36,0.93,0.66,1.46,0.89c0.48,0.21,0.97,0.38,1.48,0.45
       c0.52,0.07,1.06,0.06,1.59,0.07c0.54,0.01,1.06-0.13,1.57-0.3c0.51-0.17,0.99-0.4,1.44-0.69c0.55-0.36,1.03-0.79,1.47-1.27
       c0.01-0.01,0.03-0.02,0.04-0.02C13.93,12.3,13.94,12.31,13.96,12.32z"
        />
        <path
          d="M5.93,7.31c0.13-0.19,0.27-0.38,0.39-0.58c0.16-0.28,0.39-0.34,0.69-0.32c0.57,0.03,1.14,0.02,1.71,0.06
       c0.52,0.04,0.94,0.29,1.27,0.7c0.61,0.77,0.41,1.95-0.35,2.52c-0.41,0.31-0.88,0.43-1.38,0.43c-0.73,0.01-1.46,0-2.19,0.01
       c-0.15,0-0.2-0.07-0.2-0.2c0-0.65,0-1.31,0-1.96c0-0.12,0.05-0.17,0.17-0.17c0.25,0,0.5,0,0.75,0c0.12,0,0.17,0.05,0.17,0.17
       c0,0.34,0,0.68,0,1.01c0,0.12,0.05,0.2,0.17,0.19c0.49-0.01,0.99,0.01,1.47-0.06C8.95,9.06,9.2,8.8,9.28,8.39
       c0.06-0.3-0.14-0.68-0.4-0.85c-0.24-0.15-0.5-0.17-0.76-0.18c-0.64,0-1.28,0-1.93,0c-0.07,0-0.14,0-0.21,0
       C5.96,7.35,5.95,7.33,5.93,7.31z"
        />
        <path
          d="M0.98,8.26c0-0.54,0-1.08,0-1.63c0-0.19,0.03-0.22,0.22-0.23c0.22,0,0.43,0,0.65,0C2,6.4,2.06,6.47,2.06,6.61
       c0,0.31,0,0.62,0,0.93c0,0.21,0.03,0.24,0.24,0.24c0.56,0,1.12,0,1.68,0c0.15,0,0.2-0.06,0.2-0.2c0-0.31,0-0.62,0-0.93
       c0-0.21,0.03-0.25,0.25-0.25c0.19,0,0.39,0,0.58,0c0.2,0,0.23,0.03,0.23,0.23c0,0.99,0,1.98,0,2.97c0,0.11,0,0.21,0,0.32
       c0,0.13-0.05,0.2-0.19,0.19c-0.22,0-0.44,0-0.66,0c-0.15,0-0.22-0.06-0.22-0.22c0.01-0.32,0-0.63,0-0.95
       c0-0.15-0.05-0.22-0.21-0.22c-0.55,0.01-1.11,0-1.66,0c-0.22,0-0.25,0.03-0.25,0.25c0,0.3,0,0.6,0,0.9c0,0.21-0.04,0.24-0.24,0.24
       c-0.2,0-0.4,0-0.6,0c-0.21,0-0.24-0.03-0.24-0.24C0.98,9.34,0.98,8.8,0.98,8.26z"
        />
        <path
          d="M13.98,6.41c0.38,0,0.76,0,1.15,0c0.06,0,0.12,0.04,0.17,0.06c-0.02,0.06-0.04,0.12-0.07,0.17
       c-0.14,0.19-0.28,0.38-0.42,0.57c-0.08,0.12-0.18,0.14-0.31,0.14c-0.49,0-0.97,0-1.46,0c-0.3,0-0.59,0.05-0.83,0.26
       c-0.46,0.4-0.37,1.13,0.14,1.4c0.23,0.12,0.47,0.15,0.72,0.15c0.67,0.01,1.35,0,2.03,0.01c0.07,0,0.13,0.03,0.2,0.05
       c-0.03,0.07-0.04,0.15-0.08,0.21c-0.13,0.19-0.27,0.38-0.41,0.56c-0.05,0.06-0.15,0.11-0.22,0.11c-0.71-0.01-1.43,0.02-2.14-0.05
       c-0.62-0.06-1.1-0.41-1.4-0.98c-0.26-0.49-0.28-1-0.09-1.51c0.18-0.48,0.55-0.78,1.02-0.98c0.38-0.16,0.77-0.17,1.17-0.17
       C13.41,6.41,13.69,6.41,13.98,6.41C13.98,6.41,13.98,6.41,13.98,6.41z"
        />
        <path
          d="M14.3,10.76c-1.09,2.45-4.03,3.87-6.74,3.23c-1.37-0.32-2.49-1.04-3.38-2.12c-0.01-0.01,0.01-0.05,0.01-0.11
       c0.18,0.17,0.33,0.34,0.51,0.47c0.28,0.22,0.56,0.43,0.86,0.61c0.33,0.19,0.69,0.34,1.04,0.49c0.21,0.08,0.43,0.14,0.66,0.17
       c0.44,0.05,0.89,0.12,1.34,0.1c0.53-0.03,1.05-0.13,1.55-0.31c0.89-0.32,1.66-0.82,2.28-1.53c0.24-0.27,0.42-0.59,0.64-0.88
       c0.05-0.06,0.13-0.13,0.21-0.14c0.3-0.02,0.6-0.01,0.9,0C14.2,10.72,14.25,10.75,14.3,10.76z"
        />
        <path
          d="M14.3,5.75c-0.03,0.02-0.05,0.04-0.07,0.04c-0.35,0-0.7,0.03-1.04-0.01c-0.1-0.01-0.19-0.2-0.26-0.31
       c-0.38-0.6-0.84-1.11-1.43-1.5c-0.36-0.24-0.74-0.46-1.14-0.63C9.99,3.17,9.59,3.04,9.16,3.02C8.83,3,8.5,2.92,8.17,2.94
       c-0.58,0.02-1.15,0.12-1.7,0.32C5.71,3.52,5.05,3.95,4.46,4.5C4.37,4.58,4.29,4.66,4.17,4.77C4.19,4.7,4.18,4.65,4.2,4.63
       c0.46-0.53,0.97-1,1.58-1.37c0.72-0.43,1.48-0.68,2.3-0.81c0.68-0.11,1.35-0.06,2.01,0.06c0.49,0.09,0.96,0.26,1.42,0.48
       c0.71,0.34,1.33,0.79,1.86,1.37C13.74,4.77,14.07,5.22,14.3,5.75z"
        />
      </g>
    </svg>
  );
}

export default HDCIcon;
